import { Button } from '@mui/material'
import { useApiClient } from '~/api/useApiClient'
import { handleApiError } from './handleApiError'

export function ForceErrorButton() {
  const client = useApiClient()
  if (!import.meta.env.DEV) return null
  const fire = async () => {
    try {
      await client.rpc('walk_timeline', {
        p_fact_table: 'nonexistent_fact_table',
        p_kpi: 'x',
        p_startday: '2024-01-01',
        p_endday: '2024-12-31',
        p_bucketsize: 'month',
        p_group_by: [],
        p_filter_dims: {},
        p_aggregation: 'sum',
      })
    } catch (e) {
      handleApiError(e)
    }
  }
  return (
    <Button color="warning" variant="outlined" size="small" onClick={fire}>
      Force error (dev)
    </Button>
  )
}
